/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 16:59:54
 * @LastEditTime: 2021-04-22 17:01:46
 * @LastEditors: wangshengqiang
 * @Description: 展示产品图片的组件
 */
import React from 'react';
import styled from 'styled-components';
export default function Images({
  attrs,
  label
}) {
  const {
    imgs
  } = attrs;

  if (!imgs || !imgs.length) {
    return null;
  }

  const arr = imgs.map(item => {
    if (typeof item !== 'string') {
      return item.imageUrl;
    }

    return item;
  });
  return /*#__PURE__*/React.createElement(Container, null, arr.map((item, index) => {
    return /*#__PURE__*/React.createElement(Img, {
      key: index,
      src: item,
      alt: ""
    });
  }));
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Img = styled.img`
  display: block;
  max-width: 100%;
`;